export default "__VITE_ASSET__C_i$tcJb__"